import Notfound from "pages/notFound/NotFound";
import { lazy } from "react";

class AppPages {
  static PageKeys: Record<string, React.LazyExoticComponent<React.FC<any>>> = {
    GeneralFeature: lazy(() => import("pages/generals/views/GeneralFeature")),
    TransactionFeature: lazy(
      () => import("pages/transactionHistory/views/TransactionFeature")
    ),
    TopupManagementFeature: lazy(
      () => import("pages/topUpPackagesManagement/views/TopupManagementFeature")
    ),
    ContentManagementFeature: lazy(
      () => import("pages/contentManagement/views/ContentManagementFeature")
    ),
    RoamingManagementFeature: lazy(
      () => import("pages/roamingManagement/views/RoamingManagementFeature")
    ),
    UserManagementFeature: lazy(
      () => import("pages/usersManagement/views/UserManagementFeature")
    ),
    AddressManagementFeature: lazy(
      () => import("pages/addressManagement/views/AddressManagementFeature")
    ),
    BalanceHistoryFeature: lazy(
      () => import("pages/balanceHistory/view/BalanceHistoryFeature")
    ),
    SimOrdersForPartnersFeature: lazy(
      () =>
        import("pages/simOrdersForPartners/views/SimOrdersForPartnersFeature")
    ),
    ChangePasswordFeature: lazy(
      () => import("pages/changePassword/views/ChangePasswordFeature")
    ),
    PathConfigMangementFeature: lazy(
      () =>
        import("pages/pathConfigManagement/views/PathConfigMangementFeature")
    ),
    CountryManagementFeature: lazy(
      () => import("pages/countryManagement/views/CountryManagementFeature")
    ),
    FileManagementFeature: lazy(
      () => import("pages/fileManagement/views/FileManagementFeature")
    ),
    TravelSimListFeature: lazy(
      () => import("pages/travelSimList/views/TravelSimListFeature")
    ),
    PackagesRegistrationFeature: lazy(
      () =>
        import("pages/packagesRegistration/views/PackagesRegistrationFeature")
    ),
    VideoGenerationFeature: lazy(
      () => import("pages/videoGeneration/views/VideoGenerationFeature")
    ),
    SimTrackingFeature: lazy(
      () => import("pages/simTracking/views/SimTrackingFeature")
    ),
  };

  static getPage(key: string): any {
    return this.PageKeys[key] || Notfound;
  }
}

export default AppPages;
